import { createRoot } from "react-dom/client";
import LoadingIndicator from "./LoadingIndicator";

let root = null;
let el = null;
let pending = 0;
let hideTimer = null;
let mounted = false;

const HIDE_DELAY = 1800;

function mount() {
  if (el) return;
  el = document.createElement("div");
  el.id = "global-loading-indicator";
  document.body.appendChild(el);
  root = createRoot(el);
}

function showIndicator() {
  if (!mounted) {
    if (!el) mount();
    root.render(<LoadingIndicator />);
    mounted = true;
  }
}

function hideIndicator() {
  if (!mounted) return;
  root.render(null);
  mounted = false;
}

function show() {
  pending++;
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
  showIndicator();
}

function hide() {
  pending = Math.max(pending - 1, 0);
  if (pending > 0) return;

  hideTimer = setTimeout(() => {
    if (pending === 0) {
      hideIndicator();
    }
    hideTimer = null;
  }, HIDE_DELAY);
}

export default { show, hide };
